import { render, staticRenderFns } from "./pvanduv.vue?vue&type=template&id=3e7d5db2&scoped=true&"
import script from "./pvanduv.vue?vue&type=script&lang=js&"
export * from "./pvanduv.vue?vue&type=script&lang=js&"
import style0 from "./pvanduv.vue?vue&type=style&index=0&id=3e7d5db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d5db2",
  null
  
)

export default component.exports